
import MessageCircle from "../../../assets/duotone/MessageCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageCircleIcon({ className, dataTestid = "MessageCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
